export default __webpack_public_path__ + "static/media/voting-1.4491b477.jpg";